import { MeetingShare } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchMeetingShares(context: ApiContext, meetingId: string): Promise<MeetingShare[]> {
  return apiContextFetch<MeetingShare[]>(context, `meetings/${meetingId}/shares`)
}

export function createMeetingShare(
  context: ApiContext,
  meetingId: string,
  data: { email: string; first_name?: string; last_name?: string }
): Promise<MeetingShare> {
  return apiContextFetch<MeetingShare>(context, `meetings/${meetingId}/shares`, {
    method: "POST",
    body: JSON.stringify({ share: data }),
  })
}

export function revokeMeetingShare(context: ApiContext, meetingId: string, shareId: string): Promise<void> {
  return apiContextFetch<void>(context, `meetings/${meetingId}/shares/${shareId}`, {
    method: "DELETE",
  })
}
